/**
 * bms-open 公网域名下 API 路径改写（企微 RMS/H5 与 O2O 共用规则）
 */

export function isBmsOpenHost(hostname) {
  const host = (hostname || (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase()
  return host.indexOf('bms-open') >= 0
}

const QX_PAY_CALLBACK_SUFFIXES = [
  'tenPaymentCallBack',
  'finePaymentCallBack',
  'aiServiceFeePaymentCallBack'
]

export function rewriteOpenApiPath(path) {
  if (!path || typeof path !== 'string') {
    return path
  }
  let pathname = path
  let query = ''
  const qIdx = path.indexOf('?')
  if (qIdx >= 0) {
    pathname = path.substring(0, qIdx)
    query = path.substring(qIdx)
  }
  if (!pathname.startsWith('/')) {
    pathname = '/' + pathname
  }
  if (pathname.startsWith('/open/')) {
    return path
  }
  if (pathname === '/login') {
    return '/open/auth/login' + query
  }
  if (pathname === '/api/wxcpCallback') {
    return '/open/callback/wxcp/wxcpCallback' + query
  }
  if (pathname === '/api/createUser') {
    return '/open/api/user/createUser' + query
  }
  if (pathname.startsWith('/qxPay/')) {
    const sub = pathname.substring('/qxPay/'.length)
    const isCallback = QX_PAY_CALLBACK_SUFFIXES.some(s => sub === s || sub.endsWith('/' + s))
    if (isCallback) {
      return '/open/callback/qxPay/' + sub + query
    }
    return '/open/api/qxPay/' + sub + query
  }
  if (pathname.startsWith('/bms-api/cbm/')) {
    return '/open/api/cbm/' + pathname.substring('/bms-api/cbm/'.length) + query
  }
  if (pathname.startsWith('/bms-api/isc/')) {
    return '/open/api/isc/' + pathname.substring('/bms-api/isc/'.length) + query
  }
  return '/open/api' + pathname + query
}

export function rewriteOpenRequestUrl(url) {
  if (!url || typeof url !== 'string') {
    return url
  }
  if (!isBmsOpenHost()) {
    return url
  }
  try {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      const u = new URL(url)
      u.pathname = rewriteOpenApiPath(u.pathname)
      return u.toString()
    }
  } catch (e) {
    /* 非标准 URL，按相对路径处理 */
  }
  return rewriteOpenApiPath(url)
}
